import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { PMC8266Camera } from '@EcamModel/model/PMC8266Camera';
import { PMC8266CameraConfigs } from '@EcamModel/model/PMC8266CameraConfigs';
import { AxiosInstance } from 'axios';
import { IPMC8266CameraHttpController } from '../IPMC8266CameraHttpController';

export class PMC8266CameraHttpController
    extends BaseHttpController<PMC8266Camera>
    implements IPMC8266CameraHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'pmc8266-camera', client);
    }

    async refreshLatestPMC8266CameraConfig(cameraId: number): Promise<PMC8266CameraConfigs> {
        return await this.doPost({ path: `refresh-latest-configs/${cameraId}` }).then((res) => res.data);
    }
}
